import { createAPI } from '@common'

export default {
  // 读详情
  getNisSubject: config => createAPI('customEncryptApiName-1/0w20ojt0tvckfdu', 'get', config),
  // 修改
  postNisSubject: config => createAPI('customEncryptApiName-1/0w20ojt0tvckfdu', 'post', config),
  // 删除前状态检查
  getNisSubjectDeleteStatus: config => createAPI('customEncryptApiName-1/0w20ojt0tvckfdu0efmfuf0tubuvt', 'get', config),
  // 提交删除
  postNisSubjectDelete: config => createAPI('customEncryptApiName-1/0w20ojt0tvckfdu0efmfuf', 'post', config),
  // 查看话题讨论的详情
  getNisSubjectQa: config => createAPI('customEncryptApiName-1/0w20ojt0tvckfdu0rb', 'get', config),
  // 新建/修改话题讨论
  postNisSubjectQa: config => createAPI('customEncryptApiName-1/0w20ojt0tvckfdu0rb', 'post', config),
  // 官方回复
  postNisSubjectQaReply: config => createAPI('customEncryptApiName-1/0w20ojt0tvckfdu0rb0sfqmz', 'post', config)
}
